import classNames from 'classnames'

import { useIsScrollable } from '../../../../hooks'
import { EntityPhaseItem } from '../EntityPhaseItem'

import * as styles from './EntityPhaseList.module.css'

function EntityPhaseList({
  className = styles.EntityPhaseList,
  disabled,
  isDisabledItem,
  items,
  phaseItemClassName,
  value,
  onClick,
  ...restProps
}) {
  const { isHorizontalScrollable, ref } = useIsScrollable()

  const listClassName = classNames(className, {
    [styles.scrollable]: isHorizontalScrollable,
  })

  return (
    <div className={listClassName} ref={ref}>
      {items?.map((item, index) => (
        <EntityPhaseItem
          {...restProps}
          {...item}
          backPart={index > 0}
          className={phaseItemClassName}
          disabled={disabled || isDisabledItem?.(item)}
          frontPart={items.length === 1 || index < items.length - 1}
          key={item.id}
          selected={item.id === value}
          onClick={onClick}
        />
      ))}
    </div>
  )
}

export default EntityPhaseList
